module.exports = __webpack_public_path__ + "img/3.4f7f3c09.png";